<rt-dialog-header
  [heading]="'app.requisitions.confirm_reject_request.title' | translate"
  [subheading]="'app.requisitions.confirm_reject_request.description' | translate"
/>
<rt-dialog-body>
  <div layout-full-width>
    <rt-textarea
      [formControl]="messageControl"
      [placeholder]="'app.requisitions.confirm_reject_request.placeholder' | translate"
      [autoFocus]="true"
      [autosize]="true"
      [autoHeight]="true"
      [hasFontWeightDefault]="true"
      [rows]="5"
      [autosizeMinRows]="5"
    />
  </div>
</rt-dialog-body>
<rt-dialog-footer>
  <rt-button (click)="cancel()" variant="plain" margin-right-small>
    {{ 'app.common.cancel' | translate }}
  </rt-button>
  <rt-button (click)="submit()" [disabled]="messageControl.invalid" variant="primary">
    <rt-icon [name]="'send'" />
    {{ 'app.requisitions.confirm_reject_request.agree_label' | translate }}
  </rt-button>
</rt-dialog-footer>
